import {
  Login,
  Options,
  Layout,
  UploadPage,
  Review,
  ErrorPage,
  ChoosePage,
  Feedback,
  NotFound,
  Payment,
} from '@pages';
import './App.css';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { env } from './constants';

const domainMap = {
  dev: 'resolve-test.seel.com',
  prod: 'resolve.seel.com',
  local: 'http://localhost:3002',
};

function App() {
  const { search, href } = window.location || {};

  const navigate = useNavigate();

  // 17bp old 域名跳转到新域名
  const oldUrlRedirect = () => {
    if (href.indexOf('claims') === -1 || env === 'local') {
      return;
    }
    console.log(`//${domainMap[env]}/17track/${search}`, 'new url');
    // // 重定向 claims*  -> resolve*
    navigate(`//${domainMap[env]}/17track/${search || ''}`);
  };
  useEffect(() => {
    // console.log('pathname', pathname);
    oldUrlRedirect();
  }, []);
  return (
    <div className="App">
      <Routes>
        <Route path="*" element={<NotFound />} />
        {['/', '/17track', '/17track/index.html'].map((path) => (
          <Route path={path} key={path} element={<Layout />}>
            <Route index element={<Login />} />
            <Route path="options" element={<Options />} />
            <Route path="choose" element={<ChoosePage />} />
            <Route path="upload" element={<UploadPage />} />
            <Route path="review" element={<Review />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="payment" element={<Payment />} />
            <Route path="error" element={<ErrorPage />} />
          </Route>
        ))}
      </Routes>
    </div>
  );
}

export default App;
